/**
 * The support team: only these accounts are treated as support admins /
 * developers (support inbox access, dev replies, admin menu), instead of the
 * whole @promsys.no domain. Keep in sync with functions/src/supportTeam.ts and
 * the isPromsysDeveloper() functions in firestore.rules / storage.rules.
 */
export const SUPPORT_TEAM_EMAILS = ['vidar@promsys.no', 'bengt@promsys.no'];

export function isSupportTeamMember(email: string | null | undefined): boolean {
  return !!email && SUPPORT_TEAM_EMAILS.includes(email.toLowerCase());
}
